
import { Component } from 'vue-property-decorator';
import { Route } from 'vue-router';
import { IAggregateResultHypermediaRepresentation } from '../../shared/contracts/AggregateContract';
import { performance } from '../../shared/services/PerformanceService';
import store from '../../store/store';
import OverviewBase from './OverviewBase.vue';

@Component({})
export default class SectorOverview extends OverviewBase {
    async beforeRouteEnter(to: Route, from: Route, next: Function) {
        performance.track('Sector Dashboard');
        await store.dispatch('aggregate/fetchSectorsAggregate');
        next();
    }

    protected get aggregate(): IAggregateResultHypermediaRepresentation {
        return this.aggregateState.sectorsAggregate;
    }

    protected get title(): string {
        return 'Sector Dashboard';
    }

    protected get placeholder(): string {
        return 'Search on account cluster';
    }

    public goToDetails(id: string, name: string) {
        this.$router.push({ name: 'sectorDetails', params: { id } });
    }
}
